
import { defineComponent, ref, shallowRef, computed, watch } from "vue";
import { SiteApi } from "@/services/api/Site.service";
import { ITabConfig } from "@/interfaces/iTabConfig";
import { SITE_DEVICES_TABS } from "./siteDataTableOptions";
import VZTabs from "@/components/content/VZTabs.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "device-detail",
  components: { VZTabs },
  setup(_, { emit }) {
    const loading = ref(false);
    const route = useRoute();
    const tabs = shallowRef<ITabConfig[]>(SITE_DEVICES_TABS());
    const tableRowClick = (item) => {
      tabs.value = tabs.value.map((tab) => {
        return { ...tab, props: { ...tab.props, data: item } };
      });
    };
    const DeviceWebId = computed(() => {
      return (route.params.id as string) || ("0" as string);
    });
    const queryUpdate = async (webId: string) => {
      try {
        loading.value = true;
        const data = await SiteApi.getInstance().getDevice(+webId);
        tableRowClick(data);
        emit("updateRoute", {
          title: data.name,
          icon: "bi bi-box fs-2 text-primary",
        });
      } finally {
        loading.value = false;
      }
    };

    watch(
      DeviceWebId,
      async (val) => {
        if (val && val !== "0") {
          queryUpdate(val);
        }
      },
      { immediate: true }
    );
    return {
      tabs,
      loading,
      tableRowClick,
    };
  },
});
